import { gql } from "@apollo/client";

export const buildingQuery = gql`
  query campus($scenarioId: ID!, $filter: BuildingFilterInput) {
    data(scenarioId: $scenarioId) {
      buildings(filter: $filter) {
        items {
          id
          code
          name
        }
      }
    }
  }
`;
